import * as React from 'react';
import * as mui from '@mui/material';

interface ProductThumbnailProps {
	bookVariables: BookVariables;
	productName: string;
	meta?: { [key: string]: any };
}

interface ThumbnailIFrameProps {
	src: string;
	insideDialog?: boolean;
	productName: string;
	onClick: () => void;
}

const ThumbnailIFrame = (props: ThumbnailIFrameProps) => {
	const { src, insideDialog = false, productName, onClick } = props;
	const smUp = mui.useMediaQuery((theme: mui.Theme) => theme.breakpoints.up('sm'));

	const isVertical = productName === 'calendar1';

	const sxInsideDialog = insideDialog
		? {
				width: isVertical ? `${Math.round(70 / Math.SQRT2)}vw` : '70vw',
				height: isVertical ? '70vw' : `${Math.round(70 / Math.SQRT2)}vw`,
				maxWidth: '750px',
				maxHeight: isVertical ? `${Math.round(750 * Math.SQRT2)}px` : `${Math.round(750 / Math.SQRT2)}px`,
		  }
		: {};

	const width = smUp ? 130 : 90;

	const iframeSx = {
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		border: 'none',
		outline: '0',
		overflow: 'hidden',
		verticalAlign: 'bottom',
		width: isVertical ? `${Math.round(width / Math.SQRT2)}px` : `${width}px`,
		height: isVertical ? `${width}px` : `${Math.round(width / Math.SQRT2)}px`,
		maxWidth: 'unset!important',
	};

	const IFramePoster = (
		<mui.Box
			component='iframe'
			src={src}
			title={productName}
			sx={{
				...iframeSx,
				...sxInsideDialog,
			}}
		/>
	);

	const Img = ({ src }: { src: string }) => (
		<mui.Box
			component='img'
			src={src}
			sx={{
				...iframeSx,
				...sxInsideDialog,
			}}
		/>
	);

	return (
		<mui.Box sx={{ position: 'relative', boxShadow: 5 }}>
			<mui.Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', cursor: 'pointer' }} onClick={onClick} />

			{productName.startsWith('static_') || productName.startsWith('audiobook') ? (
				<>
					{productName === 'static_craftbook_autumn' ? (
						<Img src='https://faboo.la/wp-content/uploads/2022/12/libro_lavoretti_autunno_faboola.jpg' />
					) : productName === 'static_craftbook_winter' ? (
						<Img src='https://faboo.la/wp-content/uploads/2022/12/libro_lavoretti_INVERNO_faboola.jpg' />
					) : productName === 'static_craftbook_spring' ? (
						<Img src='https://faboo.la/wp-content/uploads/2023/03/IMM2.jpg' />
					) : productName === 'static_christmas1' ? (
						<Img src='https://faboo.la/wp-content/uploads/2022/12/libro_NATALE_faboola.jpg' />
					) : productName === 'audiobook1' ? (
						<Img src='https://faboo.la/wp-content/uploads/2023/12/prodotto_audiolibro-faboola_radici_R.jpg' />
					) : productName === 'audiobook2' ? (
						<Img src='https://faboo.la/wp-content/uploads/2023/12/prodotto_audiolibro-faboola_parole_R.jpg' />
					) : productName === 'audiobook3' ? (
						<Img src='https://faboo.la/wp-content/uploads/2023/12/prodotto_audiolibro-faboola_scoprire_R.jpg' />
					) : productName === 'audiobook4' ? (
						<Img src='https://faboo.la/wp-content/uploads/2023/12/prodotto_audiolibro-faboola_crea_R.jpg' />
					) : null}
				</>
			) : (
				<>
					{productName.includes('poster') && IFramePoster}
					{!productName.includes('poster') && (
						<mui.Box component='iframe' src={src} title={productName} sx={{ ...iframeSx, ...sxInsideDialog }} />
					)}
				</>
			)}
		</mui.Box>
	);
};

const ProductThumbnail = (props: ProductThumbnailProps) => {
	const { bookVariables, productName, meta } = props;
	const { name1, name2, name3, character1, character2, character3, city } = bookVariables;

	const [open, setOpen] = React.useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const iFrameSrc = React.useMemo(() => {
		const uniqueName = meta?.uniqueName as string | undefined;
		const uniqueCharacter = meta?.uniqueCharacter as string | undefined;

		const baseURL = 'https://faboola-renderer-wordpress-ij2yppslba-ew.a.run.app';

		let urlProductName = (() => {
			if (productName.includes('poster1')) {
				return 'story1';
			}

			if (productName.includes('poster2')) {
				return 'story2';
			}

			if (productName.includes('poster3')) {
				return 'story3';
			}

			if (productName.includes('poster4')) {
				return 'story4';
			}

			return productName;
		})();

		if (uniqueName !== undefined && uniqueCharacter !== undefined) {
			return `${baseURL}/render/${urlProductName}/lq/1?name1=${uniqueName}&name2=${uniqueName}&name3=${uniqueName}&character1=${uniqueCharacter}&character2=${uniqueCharacter}&character3=${uniqueCharacter}&city=${city}`;
		}

		return `${baseURL}/render/${urlProductName}/lq/1?name1=${name1}&name2=${name2}&name3=${name3}&character1=${character1}&character2=${character2}&character3=${character3}&city=${city}`;
	}, [bookVariables]);

	return (
		<>
			<mui.Dialog onClose={handleClose} open={open} maxWidth={false}>
				<ThumbnailIFrame src={iFrameSrc} productName={productName} onClick={handleOpen} insideDialog />
			</mui.Dialog>

			<ThumbnailIFrame src={iFrameSrc} productName={productName} onClick={handleOpen} />
		</>
	);
};

export default ProductThumbnail;
